import { defineComponent as d, computed as o, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as f, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "2f4a50ac-38b0-4f33-b5b6-cd4bc6736685" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#2f4a50ac-38b0-4f33-b5b6-cd4bc6736685)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#ffda44" d="m0 378.4 252.9-28.8L512 378.4V512H322.8L256 481l-66.8 31H0z"></path><path fill="#6da544" d="m0 256 249.8-28L512 256v122.4H0z"></path><path fill="#eee" d="m0 133.6 255.3-28.3L512 133.6V256H0z"></path><path fill="#0052b4" d="M0 0h189.2L256 30l66.8-30H512v133.6H0z"></path><path fill="#ffda44" d="m137.7 55.7 6.9 21.2H167L148.9 90l6.9 21.3-18.1-13.1-18 13.1 6.8-21.3-18-13h22.3z"></path><path fill="#d80027" d="M189.2 0h133.6v512H189.2z"></path>', 6), g = { fill: "none" }, b = ["r"], w = /* @__PURE__ */ d({
  __name: "cf",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (x, z) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (s(), c("title", u, f(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, m));
  }
});
export {
  w as default
};
//# sourceMappingURL=cf-7d8b8e70.js.map
